import { NgModule } from '@angular/core';
import { environment } from '@environments/environment';
import { MsalModule } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';

const isIE =
    window.navigator.userAgent.indexOf('MSIE ') > -1 ||
    window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
    imports: [
        MsalModule.forRoot(
            new PublicClientApplication({
                //https://learn.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-angular-auth-code
                auth: {
                    // Application (client) ID from the app registration
                    clientId: environment.msalConfig.clientId,
                    // The Azure cloud instance and the app's sign-in audience (tenant ID, common, organizations, or consumers)
                    authority: environment.msalConfig.authority,
                    // This is your redirect URI
                    redirectUri: environment.msalConfig.redirectUri,
                },
                cache: {
                    cacheLocation: 'localStorage',
                    storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
                },
            }),
            {
                interactionType: InteractionType.Redirect,
                authRequest: {
                    scopes: [environment.msalConfig.accessAPI, 'user.read',
                        'openid',
                        'profile',
                        'offline_access',],
                },
            },
            {
                interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
                protectedResourceMap: new Map([
                    [environment.msalConfig.accessAPI + '/v1.0/me', ['user.read']],
                ]),
            },
        ),
    ],
    providers: [
        // { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        /*{
			provide: AbstractSecurityStorage,
			useClass: DefaultLocalStorageService,
		},*/
    ],
})
export class AuthConfigModule {}
